// extracted by mini-css-extract-plugin
export default {"DateTime":"style_DateTime__XLx4j","Label":"style_Label__PnZ6S","TimeGroup":"style_TimeGroup__NFZMs","Separator":"style_Separator__l1oX0","Input":"style_Input__C9AbA"};